import { render, staticRenderFns } from "./MovePackages.vue?vue&type=template&id=76ae6e5c&"
import script from "./MovePackages.vue?vue&type=script&lang=js&"
export * from "./MovePackages.vue?vue&type=script&lang=js&"
import style0 from "./MovePackages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports